import React from 'react';
import {toast as createToast, ToastOptions} from 'react-toastify';
import {Header} from 'semantic-ui-react';

interface ToastProps {
	heading: string;
	message: string;
}

class useToast {
	option: ToastOptions; // https://fkhadra.github.io/react-toastify/api/toast By default, all createToast will inherit ToastContainer's props
	constructor(option: ToastOptions) {
		this.option = option;
	}

	ToastComponent = ({heading, message}: ToastProps) => {
		return (
			<>
				<Header style={{marginBottom: '5px'}} inverted size="medium">
					{heading}
				</Header>
				<b>{message}</b>
			</>
		);
	};

	success = (message: string) => {
		createToast.success(<this.ToastComponent heading="Success" message={message} />, this.option);
	};
	info = (message: string) => {
		createToast.info(<this.ToastComponent heading="Info" message={message} />, this.option);
	};
	warn = (message: string) => {
		createToast.warn(<this.ToastComponent heading="Warning" message={message} />, this.option);
	};
	error = (message: string) => {
		createToast.error(<this.ToastComponent heading="Error" message={message} />, this.option);
	};
	dark = (message: string) => {
		createToast.dark(<this.ToastComponent heading="Success" message={message} />, {
			...this.option,
			progressStyle: {background: 'green'},
		});
	};
}

export const toast = new useToast({});
